import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import RegistrationCodeForm from '../containers/RegistrationCodeFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class RegistrationCodeAddScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `RegistrationCodeAddScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('registration_code_route_add')} />
          <RegistrationCodeForm />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RegistrationCodeAddScreen;

Logger.log('silly', `RegistrationCodeAddScreen loaded.`);
